/// <reference path="../../_references.ts"/>

module App.Questionnaire {
	import TitleBarService = App.Helpers.TitleBarService;
	import ToastService = App.Utils.ToastService;

	export class ItemQuestionnaireController {
		static $inject: string[] = [
			'$state', '$q', 'Validations', 'TitleBarService', 'QuestionnaireService', 'ToastService'
		];

		token: QuestionnaireToken = null;
		itemId: number;

		loading: boolean = true;

		constructor(
			private $state: ng.ui.IStateService,
			private $q: ng.IQService,
			private validation: Validations.Validations,
			private TitleBarService: TitleBarService,
			private QuestionnaireService: QuestionnaireService,
			private ToastService: ToastService,
		) {
			TitleBarService.set('Appointment');
			this.itemId = $state.params['itemId'];

			QuestionnaireService.GetQuestionnaireToken($state.params['formId']).then((response) => {
				this.token = response.data;

				(this.token.version.questions || []).forEach((question: QuestionnaireQuestion) => {
					(this.token.responses || []).forEach((response: QuestionnaireResponse) => {
						if (response.question.id === question.id) {
							question.response = response.response;
						}
					});
				});

				this.loading = false;
			});
		}

		saveResponse(question: QuestionnaireQuestion, response: string) {
			const data: QuestionnaireResponseCreate = {
					question: question.id,
					response: response
				};

			this.QuestionnaireService.SaveQuestionnaireResponse(this.token.id, data).then(() => {
				question.response = response;
				this.ToastService.show("Saved");
			});
		}

		saveNote() {
			this.QuestionnaireService.UpdateQuestionnaireToken(this.token).then(() => {
				this.ToastService.show("Saved Observations");
			});
		}

		emailQuestionnaire() {
			const data: Object = {
				email: this.token.service_request.customer.emails[0].email
			};

			this.QuestionnaireService.EmailQuestionnaire(this.token.id, data).then(() => {
				this.ToastService.show("Email sent.");
				this.$state.go('zipSolutions.maintenance.details', { itemId: this.itemId });
			});
		}
	}
}